import { render, staticRenderFns } from "./Prepayment.vue?vue&type=template&id=66da7390&"
import script from "./Prepayment.vue?vue&type=script&lang=js&"
export * from "./Prepayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports